<template>
    <div style="margin: 5px;">
        <InputGroup>
        <InputGroupAddon>Company Short Name</InputGroupAddon>
        <InputText placeholder="Company Short Name"
                :class="{'p-invalid': isError}" 
                v-model="value" 
                :disabled="disabled"
                :required="required"
                    />
        </InputGroup>

    </div>
    

</template>  
<script>

export default {
    props: ["modelValue", 'disabled','required'],
    emits:["update:modelValue","update:error"],
    data() {
        return {
            value: ""
        }
    },
    created() {
        this.value = this.modelValue
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
    watch: {
            modelValue: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
    computed:{
        isError(){
            return  !this.value;
        }
    },
    methods: {
      
    }
}
</script>
 